import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PublishIcon from '@mui/icons-material/Publish';

const AfterDC = () => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <>
            <div style={{ width: '80%', display: 'flex', margin:'auto', marginTop:'2rem', marginBottom:'1rem'}}>
                <PublishIcon style={{ color: '#10609e' }}/>
                <p style={{ width: '80%', marginTop: '3px', marginLeft:'1rem', fontWeight:'bold', color:'#10609e' }}>After data collection is complete:</p><br />
            </div>
            <Accordion className='accordian_members' expanded={expanded === 'panel23'} onChange={handleChange('panel23')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>When will I receive the final dataset after completing data collection in my country?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ listStyleType: 'none' }}>
                            <li>When your data collection is complete and all data has been uploaded to REDCap, EYToolbox and CloudStor, the Coordinating Centre will complete a thorough
                                check of your data. A document outlining any questions the UOW team have about the data will then be uploaded to your countries CloudStor folder for your
                                team to review. This document will also highlight any missing data that needs to be addressed.</li><br />
                            <li>Please provide your responses to the questions in the document and upload any missing data as requested. The Coordinating Centre will then perform
                                another check of the data. This process will continue until all queries have been resolved.</li><br />
                            <li>Once this comprehensive review is complete, the UOW Coordinating Centre will create a finalised dataset specific to your country. If there is not
                                much missing data, this process should not take long, and we may be able to finalise the dataset within a few weeks (please note that this timeline
                                may differ depending on UOWC’s workload at the time) but on average it takes 2 months for the Pilot Study and 3 months for the Main Study. Clear
                                communication and prompt replies to our emails are crucial to facilitate the process.</li><br />
                            <li>Once the dataset is finalised, a member of the UOW Coordinating Centre will email the link to access the dataset to the Principal Investigator for your country.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel24'} onChange={handleChange('panel24')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>How do I publish the SUNRISE Data from my country?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        The SUNRISE Coordinating Centre can assist in the analysis and publication of your country’s data if required. If you want to publish data collected in
                        multiple countries, you will need to follow the SUNRISE Publication Policy (see the documents section of the SUNRISE Website) and apply to use the data.
                        Please follow the Acknowledgements section in the Publication Policy for all publications.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default AfterDC
